import ReactOnRails from "react-on-rails";

import { withStore as Sections } from "features/sections";
import { store as GivingFormStore } from "shared/components/giving-form-launcher";
// importing stores

// This is how react_on_rails can see the CampaignTileAppClient in the browser.
ReactOnRails.registerStore({ GivingFormStore });
ReactOnRails.register({ Sections });
